import { useParams } from 'react-router-dom';
import UserForm from './UserForm';
import { PageTitle } from 'app/components';

type Params = {
  userId?: string;
};

function UserCreateIndex() {
  
  const { userId } = useParams<Params>();

  const titles = [
    "Cadastro",
    "Usuários",
    userId ? "Editar" : "Cadastrar",
  ];

  return (
    <div>
      <PageTitle titles={titles} />
      <UserForm
        userId={userId}
      />
    </div>
  );
}

export default UserCreateIndex;
